export default __webpack_public_path__ + "static/media/baby.c426ab1e.mp3";